import { z } from 'zod';

/**
 * Organization response schema.
 */
export const organizationResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  fromEmail: z.string().email().nullable().optional(),
  settings: z.record(z.string(), z.unknown()).nullable(),
  createdAt: z.string().datetime().nullable(),
  updatedAt: z.string().datetime().nullable(),
});

export type OrganizationResponse = z.infer<typeof organizationResponseSchema>;

/**
 * Update organization request schema.
 */
export const updateOrganizationSchema = z.object({
  name: z.string().min(1).optional(),
  fromEmail: z.string().email().nullable().optional(),
  settings: z.record(z.string(), z.unknown()).optional(),
});

export type UpdateOrganizationRequest = z.infer<typeof updateOrganizationSchema>;

/**
 * Scheduling context — practice timezone, current date, and open status.
 */
export const schedulingContextSchema = z.object({
  timezone: z.string(),
  today: z.string(),
  currentTime: z.string(),
  anyOpenToday: z.boolean(),
  earliestSchedulableDate: z.string(),
});

export type SchedulingContext = z.infer<typeof schedulingContextSchema>;

/**
 * POST /api/auth/complete-profile: a user who signed up without an invitation
 * names their practice, which creates the organization.
 */
export const completeProfileRequestSchema = z.object({
  practiceName: z.string().min(1, 'Practice name is required').max(200),
});

export type CompleteProfileRequest = z.infer<typeof completeProfileRequestSchema>;
